export const handleNavColor = function(val = true) {
  // true #7171f7;
  // fasle #ff4747;

  const root = document.querySelector(":root");
  root.style.setProperty("--nav", val ? "#7171f7" : "#ff4747");
};
